import { Pipe, PipeTransform } from '@angular/core';

import { FrequentFlyerResponse } from '@app/entities/frequent-flyer';

@Pipe({
  name: 'frequentFlyerPrograms',
  standalone: false
})
export class FrequentFlyerProgramsPipe implements PipeTransform {

  transform(
    programs: FrequentFlyerResponse[] = [],
    defaultLoyaltyCode: string = null,
    defaultAirlineProgram: string = null
  ): string[] {
    let list = [];
    if (defaultLoyaltyCode && defaultAirlineProgram) {
      list = programs.filter(program => {
        if (program.airline_code === defaultLoyaltyCode) {
          return true;
        } else return program.program_name?.trim() !== defaultAirlineProgram;
      }).map(program => program.program_name?.trim());
    } else {
      list = programs.map(program => program.program_name?.trim());
    }
    return list.filter(item => !!item);
  }
}
